<template>

    <div>
        <aside v-if="$route.params.kravicka_id" class="sideMenu position-fixed h-100" :class="{'open': showSideMenu}">

            <router-link to="/">
                <img class="img-fluid header__logo" src="assets/img/adoptuj-kravicku-logo.svg" alt="adoptuj-kravicku-logo">
            </router-link>

            <router-link :to="{ name: 'kravicka', params: { kravicka_id: $route.params.kravicka_id } }" id="backToCow" class="sideMenu__close d-none d-xl-block">
                <span class="icon"></span>
            </router-link>

            <button id="backToDressingRoom" class="sideMenu__close d-xl-none" @click="showSideMenu=false">
                <span class="icon"></span>
            </button>

            <ul class="m-sideMenu">

                <li class="a-sideMenu__item">
                    <a :class="{'active': activeCategory === 'bezpecnost'}" @click="$emit('showProducts', 'bezpecnost', 'Bezpečnosť')">
                        <span class="icon --bezpecnost"></span>Bezpečnosť
                    </a>
                </li>

                <!--<li class="a-sideMenu__item">
                    <a :class="{'active': activeCategory === 'velkanoc'}" @click="$emit('showProducts', 'velkanoc', 'Veľká noc')">
                        <span class="icon --velkanoc"></span>Veľká noc
                    </a>
                </li>-->

                <li class="a-sideMenu__item">
                    <a :class="{'active': activeCategory === 'vianoce'}" @click="$emit('showProducts', 'vianoce', 'Vianoce')">
                        <span class="icon --vianoce"></span>Vianoce
                    </a>
                </li>

                <li class="a-sideMenu__item">
                    <a :class="{'active': activeCategory === 'oblecenie'}" @click="$emit('showProducts', 'oblecenie', 'Oblečenie')">
                        <span class="icon --oblecenie"></span>Oblečenie
                    </a>
                </li>

                <li class="a-sideMenu__item">
                    <a :class="{'active': activeCategory === 'obuv'}" @click="$emit('showProducts', 'obuv', 'Obuv')">
                        <span class="icon --obuv"></span>Obuv
                    </a>
                </li>


                <li class="a-sideMenu__item">
                    <a :class="{'active': activeCategory === 'ciapky'}" @click="$emit('showProducts', 'ciapky', 'Čiapky')">
                        <span class="icon --ciapky"></span>Čiapky
                    </a>
                </li>

                <li class="a-sideMenu__item">
                    <a :class="{'active': activeCategory === 'doplnky'}" @click="$emit('showProducts', 'doplnky', 'Doplnky')">
                        <span class="icon --doplnky"></span>Doplnky
                    </a>
                </li>

                <!-- TODO zmenaren-->
                <!--<li class="a-sideMenu__item &#45;&#45;spaceTop">-->
                <!--<router-link :to="{ name: 'zmenaren', params: { kravicka_id: $route.params.kravicka_id } }">-->
                <!--<span class="icon &#45;&#45;zmenaren"></span>Zmenáreň-->
                <!--</router-link>-->
                <!--</li>-->

                <li class="a-sideMenu__item --textLink">
                    <router-link :to="{ name: 'kravicka', params: { kravicka_id: $route.params.kravicka_id } }">
                        Zavrieť šatník<span class="icon --zavriet"></span>
                    </router-link>
                </li>

            </ul>

        </aside>

        <button id="openShopMenu" class="btn --primary d-xl-none" @click="showSideMenu=true"><span class="icon"></span></button>

    </div>

</template>



<script>
    export default {
        props: [
            'kravicka',
            'activeCategory'
        ],
        data() {
            return {
                showSideMenu: false,
            }
        },
        mounted() {
        },
        methods: {
        }
    }
</script>
